import { ConvenienceTestDraftParams, ConvenienceTestDraftResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const putConvenienceTestsDraft = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: ConvenienceTestDraftParams
}): Promise<AxiosResponse<ConvenienceTestDraftResponse>> => {
  return api.put<ConvenienceTestDraftResponse>('/user/me/convenience-tests/draft', params)
}
